import { render } from "./FormTable.vue?vue&type=template&id=6071739c&scoped=true"
import script from "./FormTable.vue?vue&type=script&lang=js"
export * from "./FormTable.vue?vue&type=script&lang=js"

import "./FormTable.vue?vue&type=style&index=0&id=6071739c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6071739c"]])

export default __exports__